export default {"src":"https://images-cdn.curipod.com/d-b62f7b0a/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};